import React, { useState } from 'react';
import { Button } from '@telus-uds/components-web';
import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
} from './css';


const FmSaleSupportStatusBar = ({
  step,
  isLastStep,
  onProceedClick,
  onBackClick
}) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      submitButtonLabel
    }
  } = localizedStrings;



  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
            <>
              {step !== 1 && (
                <Button variant={{ priority: 'high' }} type="button"
                  onClick={onBackClick}
                  style={{ marginRight: '1em' }}>
                  {backLabel}
                </Button>
              )}

              <Button
                type="button"
                onClick={e => onProceedClick(e)}
                variant={{ priority: 'high' }}
              >
                {isLastStep ? "Cancel" : continueButtonLabel}
              </Button>
            </>

        </BoxWrapper>
      </div>

    </StatusBarWrapper>
  );
};

FmSaleSupportStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
};

export default FmSaleSupportStatusBar;
